import { render } from "./YoutubePlayer.vue?vue&type=template&id=5c9bd881&ts=true"
import script from "./YoutubePlayer.vue?vue&type=script&lang=ts"
export * from "./YoutubePlayer.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__